/**
 * @description Contains constaints used by the whole UI module
 */

import BusinessIcon from '@mui/icons-material/Business';
import DescriptionIcon from '@mui/icons-material/Description';
import PersonIcon from '@mui/icons-material/Person';
import PlaceIcon from '@mui/icons-material/Place';
import AssessmentIcon from '@mui/icons-material/Assessment';
import HelpIcon from '@mui/icons-material/Help';
import DvrIcon from '@mui/icons-material/Dvr';
import DisplaySettingsIcon from '@mui/icons-material/DisplaySettings';
import ArticleIcon from '@mui/icons-material/Article';
import SimCardAlertIcon from '@mui/icons-material/SimCardAlert';
import LockIcon from '@mui/icons-material/Lock';
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';

// Defines a map of categories for the knowledge center, indexed by their category id.  Each category contains some settings, like a name and an icon
export const CATEGORIES = [
  {
    Icon: ArticleIcon,
    label: 'Classified Materials',
    value: 'Classified Materials'
  },
  {
    Icon: DescriptionIcon,
    label: 'Contracts',
    value: 'Contracts'
  },
  {
    Icon: DvrIcon,
    label: 'Employee Portal',
    value: 'Employee Portal'
  },
  {
    Icon: BusinessIcon,
    label: 'Facilities',
    value: 'Facilities'
  },
  {
    Icon: SimCardAlertIcon,
    label: 'Incidents',
    value: 'Incidents'
  },
  {
    Icon: HelpIcon,
    label: 'Other',
    value: 'Other'
  },
  {
    Icon: PersonIcon,
    label: 'Personnel',
    value: 'Personnel'
  },
  {
    Icon: DisplaySettingsIcon,
    label: 'Program Manager Portal',
    value: 'Program Manager Portal'
  },
  {
    Icon: AssessmentIcon,
    label: 'Reports',
    value: 'Reports'
  },
  {
    Icon: LockIcon,
    label: 'Safe/Closed Areas',
    value: 'Safe/Closed Areas'
  },
  {
    Icon: SupervisorAccountIcon,
    label: 'Systems Administration',
    value: 'Systems Administration'
  },
  {
    Icon: PlaceIcon,
    label: 'Visits',
    value: 'Visits'
  }
];

// Defines the master role option
export const MASTER_ROLE = { value: 'ROLE_MASTER', label: 'Master' };

// Defines a list of roles for displaying specific knowledge entries
export const ROLES = [
  { value: 'ROLE_EMP', label: 'Client Employee' },
  { value: 'ROLE_CFSO', label: 'Client FSO' },
  { value: 'ROLE_CLMGR', label: 'Client Manager' },
  { value: 'ROLE_COMPLIANCE', label: 'Compliance' },
  { value: 'ROLE_HELPDESK', label: 'Help Desk' },
  { value: 'ROLE_ITCOMPLIANCE', label: 'IT Compliance' },
  { value: 'ROLE_ITHELPDESK', label: 'IT Help Desk' },
  MASTER_ROLE,
  { value: 'ROLE_PM', label: 'Program Manager' }
];

// Defines the administration mode that the knowledge form will be using
export const ADMIN_MODE = {
  ADD: 'ADD',
  EDIT: 'EDIT'
};
